// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1Awwp","content":"GlobalSearch_content__2H95w"};